<template>
  <base-page
    :title="'Coupons'"
  >
    <template #actionButton>
      <v-btn
        outlined
        rounded
        color="primary"
        @click="$router.push({ name: 'create-coupon' })"
      >
        <v-icon left>
          add
        </v-icon>

        Add Coupon
      </v-btn>
    </template>

    <template #main>
      <coupon-list />
    </template>
  </base-page>
</template>
<script>
  import BasePage from '@/views/BasePage.vue'
  import CouponList from '@/components/Coupon/CouponList.vue'

  export default {
    components: {
      BasePage,
      CouponList
    },
  }
</script>
